<template>
  <div class="history-order">
    <div class="container">
      <a href="javascript:void(0);" class="go-back" @click="$router.go(-1)">
        Повернутися
      </a>
      <div :class="['history-order__wrapp', { 'disabled': documentDisabled }]">
        <!-- Страховий продукт -->
        <div class="history-order__item">
          <div class="history-order__head">
            Страховий продукт
          </div>
          <div class="history-order__form-group">
            <div class="row">
              <div class="col-md-4">
                <label>Компанія</label>
                <input v-if="skeletonOff" type="text" class="form-control" :value="companyName" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
              <div class="col-md-4">
                <label>Страхова сума</label>
                <input v-if="skeletonOff" type="text" class="form-control" :value="insuranceSum" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
            </div>
          </div>
        </div>

        <!-- Розрахунок -->
        <div class="history-order__item">
          <div class="history-order__head">
            Розрахунок
          </div>
          <div class="history-order__form-group">
            <div class="history-order__form-heading">Дати дії договору:</div>
            <div class="row">
              <div class="col-md-4">
                <label>Початок</label>
                <input v-if="skeletonOff" disabled :value="order.contract.startedAt || searchInfo.startDate" class="form-control date-selector">
                <PuSkeleton v-else class="skeleton-input" />
              </div>
              <div class="col-md-4">
                <label>Закінчення</label>
                <input v-if="skeletonOff" disabled :value="order.contract.finishedAt" class="form-control date-selector">
                <PuSkeleton v-else class="skeleton-input" />
              </div>
              <div class="col-md-4">
                <label>Термін дії договору</label>
                <input v-if="skeletonOff" type="text" class="form-control" :value="periodLabel" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
            </div>
          </div>
          <div class="history-order__form-group">
            <div class="history-order__form-heading">Параметри захисту:</div>
            <div class="row">
              <div class="col-md-4">
                <label>Період дії страхового захисту</label>
                <input v-if="skeletonOff" type="text" class="form-control" :value="protectionPeriodLabel" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
              <div class="col-md-4">
                <label>Територія страхування</label>
                <input v-if="skeletonOff" type="text" class="form-control" :value="territoryLabel" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
            </div>
          </div>
          <div class="history-order__form-group">
            <div class="history-order__form-heading">Фактори, що впливають на фінальну вартість:</div>
            <div class="row">
              <div class="col-md-4">
                <label>Воєнні ризики</label>
                <input v-if="skeletonOff" type="text" class="form-control" :value="warRiskLabel" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
              <div class="col-md-4">
                <label>Спорт</label>
                <input v-if="skeletonOff" type="text" class="form-control" :value="sportLabel" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
              <div class="col-md-4">
                <label>Професія</label>
                <input v-if="skeletonOff" type="text" class="form-control" :value="professionLabel" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
            </div>
            <div class="row" style="margin-top: 15px;">
              <div v-if="birthDate" class="col-md-4">
                <label>Дата народження застрахованої особи</label>
                <input v-if="skeletonOff" type="text" class="form-control" :value="birthDate" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
            </div>
          </div>
        </div>

        <!-- Дані страхувальника -->
        <div class="history-order__item history-order__client">
          <div class="history-order__head">
            Дані страхувальника
          </div>
          <div class="history-order__form-group">
            <div class="history-order__form-heading">Ідентифікація:</div>
            <div class="row">
              <div class="col-md-4">
                <label>{{ isLegalType() ? 'ЄДРПОУ' : 'ІПН' }}</label>
                <input v-if="skeletonOff" type="text" class="form-control" :value="payerPerson.uin" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
              <div v-if="!isLegalType()" class="col-md-4">
                <label>Дата народження</label>
                <input v-if="skeletonOff" :value="payerPerson.birthDate" class="form-control date-selector" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
              <div v-if="!isLegalType()" class="col-md-4">
                <label>Прізвище</label>
                <input v-if="skeletonOff" type="text" class="form-control" :value="payerPerson.surname" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
              <div :class="isLegalType() ? 'col-md-12' : 'col-md-4'">
                <label>Ім'я</label>
                <input v-if="skeletonOff" type="text" class="form-control" :value="payerPerson.name" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
              <div v-if="!isLegalType()" class="col-md-4">
                <label>По батькові</label>
                <input v-if="skeletonOff" type="text" class="form-control" :value="payerPerson.patronymic" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
            </div>
          </div>
          <div class="history-order__form-group">
            <div class="history-order__form-heading">Контактна інформація:</div>
            <div class="row">
              <div class="col-md-4">
                <label>Телефон</label>
                <input v-if="skeletonOff" type="text" class="form-control" :value="payerPerson.phone" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
              <div class="col-md-4">
                <label>Email</label>
                <input v-if="skeletonOff" type="text" class="form-control" :value="payerPerson.email" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
              <div class="col-md-4">
                <label>Адреса</label>
                <input v-if="skeletonOff" type="text" class="form-control" :value="payerPerson.address" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
            </div>
          </div>
          <div class="history-order__form-group">
            <div class="history-order__form-heading">Документ, що посвідчує особу:</div>
            <div class="row">
              <div class="col-md-4">
                <label>Документ</label>
                <input v-if="skeletonOff" type="text" class="form-control" :value="showTypeDocument(payerPerson.documentType)" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
              <div class="col-md-4">
                <label>Орган, що видав</label>
                <input v-if="skeletonOff" type="text" class="form-control" :value="payerPerson.issuedBy" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
            </div>
            <div class="row" style="margin-top: 15px;">
              <div class="col-md-4">
                <label>{{ isDocumentIdCard(payerPerson.documentType) ? 'Запис №' : 'Серія №' }}</label>
                <input v-if="skeletonOff" type="text" class="form-control" :value="payerPerson.serial" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
              <div class="col-md-4">
                <label>Документ №</label>
                <input v-if="skeletonOff" type="text" class="form-control" :value="payerPerson.number" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
              <div class="col-md-4">
                <label>Дата видачі</label>
                <input v-if="skeletonOff" :value="payerPerson.dateOfIssue" class="form-control date-selector" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
            </div>
          </div>
        </div>

        <!-- Дані застрахованої особи -->
        <div v-if="insuredPerson" class="history-order__item">
          <div class="history-order__head">
            Дані застрахованої особи
          </div>
          <div class="history-order__form-group">
            <div class="history-order__form-heading">Ідентифікація:</div>
            <div class="row">
              <div class="col-md-4">
                <label>ІПН</label>
                <input v-if="skeletonOff" type="text" class="form-control" :value="insuredPerson.uin" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
              <div class="col-md-4">
                <label>Дата народження</label>
                <input v-if="skeletonOff" :value="insuredPerson.birthDate" class="form-control date-selector" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
              <div class="col-md-4">
                <label>Прізвище</label>
                <input v-if="skeletonOff" type="text" class="form-control" :value="insuredPerson.surname" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
              <div class="col-md-4">
                <label>Ім'я</label>
                <input v-if="skeletonOff" type="text" class="form-control" :value="insuredPerson.name" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
              <div class="col-md-4">
                <label>По батькові</label>
                <input v-if="skeletonOff" type="text" class="form-control" :value="insuredPerson.patronymic" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
            </div>
          </div>
          <div class="history-order__form-group">
            <div class="history-order__form-heading">Контактна інформація:</div>
            <div class="row">
              <div class="col-md-4">
                <label>Телефон</label>
                <input v-if="skeletonOff" type="text" class="form-control" :value="insuredPerson.phone" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
              <div class="col-md-4">
                <label>Email</label>
                <input v-if="skeletonOff" type="text" class="form-control" :value="insuredPerson.email" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
              <div class="col-md-4">
                <label>Адреса</label>
                <input v-if="skeletonOff" type="text" class="form-control" :value="insuredPerson.address" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
            </div>
          </div>
          <div v-if="insuredPerson.number || insuredPerson.serial" class="history-order__form-group">
            <div class="history-order__form-heading">Документ, що посвідчує особу:</div>
            <div class="row">
              <div class="col-md-4">
                <label>Документ</label>
                <input v-if="skeletonOff" type="text" class="form-control" :value="showTypeDocument(insuredPerson.documentType)" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
              <div class="col-md-4">
                <label>Орган, що видав</label>
                <input v-if="skeletonOff" type="text" class="form-control" :value="insuredPerson.issuedBy" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
            </div>
            <div class="row" style="margin-top: 15px;">
              <div class="col-md-4">
                <label>{{ isDocumentIdCard(insuredPerson.documentType) ? 'Запис №' : 'Серія №' }}</label>
                <input v-if="skeletonOff" type="text" class="form-control" :value="insuredPerson.serial" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
              <div class="col-md-4">
                <label>Документ №</label>
                <input v-if="skeletonOff" type="text" class="form-control" :value="insuredPerson.number" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
              <div class="col-md-4">
                <label>Дата видачі</label>
                <input v-if="skeletonOff" :value="insuredPerson.dateOfIssue" class="form-control date-selector" disabled>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
            </div>
          </div>
        </div>

        <!-- Інше -->
        <div class="history-order__item">
          <div class="history-order__head">
            Інше
          </div>
          <div class="history-order__form-group">
            <div class="row">
              <div class="col-md-8">
                <label>Примітки:</label>
                <textarea v-if="skeletonOff" class="form-control" disabled></textarea>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
            </div>
          </div>
          <div class="history-order__form-group border-none m-b-none">
            <div class="row">
              <div class="col-md-8">
                <label>Створити на підставі даного договору новий договір:</label>
                <select v-if="skeletonOff" class="form-control" disabled>
                  <option value="12">Нещасний випадок</option>
                </select>
                <PuSkeleton v-else class="skeleton-input" />
              </div>
            </div>
          </div>
        </div>

        <!-- Ціна -->
        <div class="history-order__price">
          <div class="row">
            <div class="col-md-8">
              <div class="history-order__price__item">
                <p>Первісна вартість:</p>
                <b> {{ showPrice() }} <span>грн</span></b>
              </div>
            </div>
          </div>
        </div>
        <div v-if="showDiscountPrice()" class="history-order__price">
          <div class="row">
            <div class="col-md-8">
              <div class="history-order__price__item">
                <p>Вартість зі знижкою:</p>
                <b> {{ showDiscountPrice() }} <span>грн</span></b>
              </div>
            </div>
          </div>
        </div>

        <!-- Кнопки дій -->
        <div v-if="loadData" class="partner-order__nav">
          <div class="row">
            <div v-if="order.edit" class="col-md-8">
              <div class="row">
                <div v-if="order.statusId == 1 && user && user.recipientTypeId !== 4" class="col-md-6">
                  <button type="button" @click="declare(order)" class="btn-blue-w">Редагувати і заявити</button>
                </div>
                <div v-if="order.statusId == 5 && user && user.recipientTypeId !== 4" class="col-md-6">
                  <button :disabled="isConcludeProcess" type="button" @click="declare(order, false, false, 2)" class="btn-blue-w">
                    <span v-if="isConcludeProcess" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span v-else>Продовжити</span>
                  </button>
                </div>
                <div class="col-md-6">
                  <button type="button" @click="draft()" class="btn btn-dark">Переглянути чернетку</button>
                </div>
              </div>
            </div>
            <div v-if="!hideCopyForApi" class="col-md-4">
              <button :disabled="isCopyProcess" type="button" @click="copy(order)" class="btn btn-success">
                <span v-if="isCopyProcess" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span v-else>Копіювати</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { showOrder } from '@/api/order';
import { rawApiData } from '@/views/accident/data/sportTypes';
import { customerMixin, HistoryMixin } from '../../mixin';

export default {
  name: 'InsuranceAccidentInfo',
  components: { Multiselect },
  mixins: [customerMixin, HistoryMixin],
  data() {
    return {
      loadMoreOptions: {},
      loadData: false,
      skeletonOff: false,
      isCopyProcess: false,
      isConcludeProcess: false,
      documentDisabled: true,
      orderPeriod: '1 рік',
      order: {
        offer: {},
        contract: {},
        companyInfo: {},
        insuranceObject: {},
        insurant: {
          documentation: {},
        },
        clientRequest: {},
        accidentOffer: {}
      }
    };
  },

  async created() {
    try {
      const response = await showOrder(this.$route.params.orderId, this.$route.params.typeId || 12);
      this.order = response.data.data;
    } catch (e) {
      console.error(e);
    } finally {
      this.loadData = true;
      this.skeletonOff = true;
    }
  },

  computed: {
    user() {
      return this.$store.getters.USER;
    },
    hideCopyForApi() {
      return true;
    },
    isContractConcluded() {
      return this.order.statusId == 2 || (this.order.contract && this.order.contract.mtsbuCode);
    },
    searchInfo() {
      return this.order.clientRequest?.searchInfo || {};
    },
    payer() {
      return this.order.clientRequest?.payer || {};
    },
    insured() {
      return this.order.clientRequest?.insured || {};
    },
    accidentOffer() {
      return this.order.accidentOffer || {};
    },
    companyName() {
      return this.order.companyInfo?.publicName || this.order.companyInfo?.name || '';
    },
    insuranceSum() {
      const sum = this.accidentOffer?.amount || this.searchInfo?.sum;
      if (sum) {
        return Number(sum).toLocaleString('uk-UA') + ' грн';
      }
      return this.order.offer?.coverage || '';
    },
    periodLabel() {
      const p = this.accidentOffer?.period || this.searchInfo?.period;
      if (!p) return this.orderPeriod || '';
      const periodMap = {
        '12_month': '1 рік',
        '365': '1 рік',
        '9_month': '9 місяців',
        '6_month': '6 місяців',
        '180': '6 місяців',
        '3_month': '3 місяці',
        '90': '3 місяці',
        '30_days': '30 днів',
        '30': '30 днів',
        '15_days': '15 днів',
        '15': '15 днів',
        '10_days': '10 днів',
        '10': '10 днів',
        '1_month': '1 місяць'
      };
      return periodMap[p] || (typeof p === 'string' && p.includes('_') ? `${p.split('_')[0]} днів` : `${p} днів`);
    },
    protectionPeriodLabel() {
      const pp = this.accidentOffer?.protection_period || this.searchInfo?.protectionPeriod;
      if (pp === '24_7') return '24/7';
      if (pp === 'study_work_hours' || pp === 'working_hours') return 'Під час учбових занять / службових обов’язків';
      if (pp === 'sport_hours') return 'Під час занять спортом/змагань';
      return pp || '24/7';
    },
    territoryLabel() {
      const cId = this.accidentOffer?.country_id || this.searchInfo?.countryId;
      return cId == 1 ? 'Україна' : (cId == 2 ? 'Весь світ (за винятком України)' : 'Україна');
    },
    warRiskLabel() {
      const warRisk = Boolean(this.searchInfo?.warRisk) || (this.accidentOffer?.active_factor === 'warRisk' && Boolean(Number(this.accidentOffer?.active_factor_value)));
      return warRisk ? 'Включено' : 'Без покриття';
    },
    sportLabel() {
      const sport = this.searchInfo?.sportType || this.accidentOffer?.all_data?.sport_type;
      if (!sport || sport === 'none' || sport === '140995') return 'Без спорту';
      const item = rawApiData.find(s => s.Code == sport || s.Coefficient == sport || s.Id == sport || s.Name == sport);
      return item ? item.Name : sport;
    },
    professionLabel() {
      const prof = this.searchInfo?.profession || this.accidentOffer?.all_data?.profession;
      if (!prof || prof === 'none') return 'Без підвищеного ризику';
      const profMap = {
        builder: 'Будівельник',
        electrician: 'Електрик',
        firefighter: 'Пожежник',
        guard: 'Охоронець',
        other: 'Інші',
      };
      return profMap[prof] || prof;
    },
    birthDate() {
      return this.searchInfo?.birthDate || this.insuredPerson?.birthDate || this.payerPerson?.birthDate || '';
    },
    payerPerson() {
      const p = this.payer;
      return {
        surname: this.order.insurant?.surname || p.surname || '',
        name: this.order.insurant?.name || p.name || '',
        patronymic: this.order.insurant?.patronymic || p.patronymic || '',
        birthDate: this.order.insurant?.dateBirthAt || p.dateBirth || '',
        uin: this.order.insurant?.documentation?.uin || p.identificationCode || '',
        phone: this.order.insurant?.phone || p.phone || '',
        email: this.order.insurant?.email || p.mail || '',
        address: this.order.insurant?.address || [p.city, p.street, p.house ? 'буд. ' + p.house : '', p.apartment ? 'кв. ' + p.apartment : ''].filter(Boolean).join(', '),
        documentType: this.order.insurant?.documentation?.type || p.documentation?.type,
        issuedBy: this.order.insurant?.documentation?.issuedBy || p.documentation?.issuedBy || '',
        serial: this.order.insurant?.documentation?.serial || p.documentation?.serial || '',
        number: this.order.insurant?.documentation?.number || p.documentation?.number || '',
        dateOfIssue: this.order.insurant?.documentation?.dateOfIssue || p.documentation?.dateOfIssue || '',
      };
    },
    insuredPerson() {
      const ins = this.insured;
      if (!ins || (!ins.surname && !ins.name && !ins.identificationCode)) {
        return null;
      }
      return {
        surname: ins.surname || '',
        name: ins.name || '',
        patronymic: ins.patronymic || '',
        fullName: [ins.surname, ins.name, ins.patronymic].filter(Boolean).join(' '),
        birthDate: ins.dateBirth || '',
        uin: ins.identificationCode || '',
        phone: ins.phone || '',
        email: ins.mail || '',
        address: [ins.city, ins.street, ins.house ? 'буд. ' + ins.house : '', ins.apartment ? 'кв. ' + ins.apartment : ''].filter(Boolean).join(', '),
        documentType: ins.documentation?.type,
        serial: ins.documentation?.serial || '',
        number: ins.documentation?.number || '',
        dateOfIssue: ins.documentation?.dateOfIssue || '',
        issuedBy: ins.documentation?.issuedBy || '',
      };
    }
  },

  methods: {
    draft() {
      window.open(`/api/orders/draft/${this.$store.getters.USER.id}/${this.$route.params.orderId}`, '_blank');
    },

    isLegalType() {
      return this.isLegalCustomerType(this.order.insurant?.type_id || this.order.insurant?.customerTypeId);
    },

    isDocumentIdCard(type = null) {
      const docType = type ?? this.order.insurant?.documentation?.type ?? this.payerPerson?.documentType;
      return docType == 3 || docType === 'DOCUMENT_ID_CARD';
    },

    showTypeDocument(type = null) {
      const docType = type ?? this.order.insurant?.documentation?.type ?? this.payerPerson?.documentType;
      if (!docType) return '';
      const doc = this.$_.findWhere(this.$store.getters.DOCUMENTS_TYPES, { id: parseInt(docType) }) ||
                  this.$_.findWhere(this.$store.getters.DOCUMENTS_TYPES, { code: docType }) ||
                  this.$_.findWhere(this.$store.getters.DOCUMENTS_TYPES, { key: docType }) ||
                  this.$_.findWhere(this.$store.getters.DOCUMENTS_TYPES, { uid: parseInt(docType) });
      if (doc?.name) return doc.name;
      const map = {
        '1': 'Паспорт громадянина України',
        'DOCUMENT_PASSPORT': 'Паспорт громадянина України',
        '2': 'Паспорт для виїзду за кордон',
        'DOCUMENT_EXTERNAL_PASSPORT': 'Паспорт для виїзду за кордон',
        '3': 'ID-картка',
        'DOCUMENT_ID_CARD': 'ID-картка',
        '4': 'Посвідчення водія',
        'DOCUMENT_DRIVER_LICENCE': 'Посвідчення водія',
      };
      return map[docType] || docType;
    },

    showPrice() {
      const price = parseFloat(this.order.price || 0);
      return isNaN(price) ? '0.00' : price.toFixed(2);
    },

    showDiscountPrice() {
      if (this.order.discountPrice) {
        const price = parseFloat(this.order.discountPrice);
        return isNaN(price) ? 0 : price.toFixed(2);
      }
      return 0;
    },

    isFisReferal() {
      return false;
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
